<template>
    <div fluid fill-height>
      <v-expand-x-transition>
        <landing-toolbar />
      </v-expand-x-transition>
      <v-container style="min-width:100% !important">
        <Authorization />
      </v-container>
    </div>
</template>
  
  <script>
  import Authorization from '@/components/Definiciones/Autorizaciones/Authorization.vue';
  import LandingToolbar from '@/components/LandingToolbar/LandingToolbar.vue'
  export default {
    components: { Authorization, LandingToolbar },
  };
  </script>
  